"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCenterFromNeSw = exports.parseGeoString = void 0;
exports.parseGeoString = function (geostring) {
    var _a = geostring.split('-')[1].split('_'), neStr = _a[0], swStr = _a[1];
    var _b = neStr.split('~'), neLat = _b[0], neLng = _b[1];
    var _c = swStr.split('~'), swLat = _c[0], swLng = _c[1];
    return { ne: { lat: Number(neLat), lng: Number(neLng) }, sw: { lat: Number(swLat), lng: Number(swLng) } };
};
exports.getCenterFromNeSw = function (ne, sw) {
    var center = { lat: (ne.lat - sw.lat) / 2 + sw.lat, lng: (ne.lng - sw.lng) / 2 + sw.lng };
    return center;
};
